/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents, MailRequirementSetting } from '@gh/builder-shared-data';
import { ActionFlow, EnumDictionary, getRouteInitData, TextDictionary } from '@gh/common-shared';
import { ID, OfficeData } from '@gh/common-shared-data';
import { DialogService, yesAnswer, yesNoConfirmation } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { assign } from 'lodash';
import { SystemVariablesContactsDetails } from '../../resources/model/system-vars-contacts-details.model';
import { SystemVarsContactsTabBusinessService } from '../../resources/system-vars-contacts-tab-business.service';
import { SystemVarsContactsTabFormState } from './system-vars-contacts-tab-form.service';

@Component({
  selector: 'gh-system-vars-contacts-tab',
  template: require('./system-vars-contacts-tab.component.html'),
  styles: [require('./system-vars-contacts-tab.component.scss')],
  viewProviders: [SystemVarsContactsTabFormState],
})
export class SystemVarsContactsTabComponent extends AbstractFormComponent<SystemVariablesContactsDetails> implements OnInit {
  email: EnumDictionary<MailRequirementSetting>;
  original: SystemVariablesContactsDetails;
  states: TextDictionary;

  constructor(private route: ActivatedRoute,
              private businessService: SystemVarsContactsTabBusinessService,
              public form: SystemVarsContactsTabFormState,
              private navigationService: BuilderNavigationService,
              private userContext: BuilderUserContext,
              private pipelines: FormActionPipelines,
              private actions: CommonActions,
              private dialogService: DialogService) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<SystemVariablesContactsDetails>> {
    return this.pipelines.complete({
      execute: this.actions.execute((state: FormFlowState<SystemVariablesContactsDetails>) =>
        this.businessService.update(state.form.submitValue)),
      finish: (state: FormFlowState<SystemVariablesContactsDetails>) => {
        const { value } = state;
        this.original = value;
        this.form.build(value);
      },
    });
  }

  ngOnInit(): void {
    const { contactSettings: original, ...init } = getRouteInitData(this.route);
    assign(this, init, { original });
    this.form.build(original);
  }

  onReset(): void {
    this.dialogService
      .confirmation(yesNoConfirmation('msg_reset')).pipe(
      filter$(yesAnswer))
      .subscribe(() => this.form.build(this.original));
  }

  goToAel(entityId?: ID, entityType?: string, label?: string): void {
    const office = <OfficeData>this.userContext.office;
    this.navigationService.goToAel({
      entityId: entityId ? entityId : office.id,
      entityType: entityType ? entityType : 'OFFICE',
      eventTypeIds: [AelEvents.Office.EditedContacts],
      label: label ? label : 'lbl_menu_contacts',
    });
  }
}
